import { Divider } from '@mui/material'
import { get as GetValue, isEmpty, isObject, merge as MergeObject } from 'lodash'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Panel } from '../../../../components'
import { CampaignEditSlice } from '../../../../reducers'
import { SectionMap } from '../../../../reducers/campaign-edit/slice'
import { useCampaignFormContext } from '../../campaign-form-context'
import ReviewInformation from '../review-information'
import { useStyles } from './style'

const ReviewInformationPanel = React.memo(() => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { form } = useCampaignFormContext()

  const campaign = React.useMemo(() => form.getValues(), [form])
  const sections = useSelector(CampaignEditSlice.selectors.sections)

  React.useEffect(() => {
    const sectionsCopy = MergeObject({}, SectionMap)
    Object.values(sectionsCopy).forEach(section => {
      Object.values(section.steps).forEach(step => {
        const value = GetValue(campaign, step.name)
        if (
          !value || (Array.isArray(value) && !value.length) ||
          (isObject(value) && isEmpty(value))
        ) step.valid = false
        else step.valid = true
      })
    })
    dispatch(CampaignEditSlice.actions.setSections(sectionsCopy))
  }, [campaign, dispatch])

  return (
    <Panel
      padding={16}
      aria-label='filling information panel'
      role='complementary'
      tabIndex={0}
    >
      {Object.entries(sections).map(([key, section], index, entries) => (
        <div key={key} className={classes.stepsContainer}>
          <ReviewInformation value={key} section={section} isSelected />
          {!(entries.length === index + 1) && <Divider className={classes.stepDivider} />}
        </div>
      ))}
    </Panel>
  )
})

export default ReviewInformationPanel
